import { useState, useEffect } from "react";
import { resolveImageUrl } from "../../utils/imageUrl";

/**
 * SafeImage — renders an <img> but if the request 404s (e.g. an upload was
 * wiped during a redeploy) we swap to a `fallback` node instead of letting
 * the broken-image glyph leak into the UI. The src is normalised through
 * resolveImageUrl so any stored URL shape (relative, legacy, stale-domain)
 * resolves to a loadable URL.
 */
const SafeImage = ({ src, alt = "", className = "", fallback = null, ...rest }) => {
  const [errored, setErrored] = useState(false);
  const resolved = resolveImageUrl(src);

  // Reset on src change so a new image gets a fresh chance.
  useEffect(() => {
    setErrored(false);
  }, [src]);

  if (!resolved || errored) return fallback;

  return (
    <img
      src={resolved}
      alt={alt}
      className={className}
      onError={() => setErrored(true)}
      {...rest}
    />
  );
};

export default SafeImage;
